import React from 'react' // eslint-disable-line no-unused-vars
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import configureStore from './configureStore'
import App from './App'
import { config } from './json/config.json'

const store = configureStore()

const Component = () => (
  <Provider store={store}>
    <App />
  </Provider>
)

const render = () => {
  ReactDOM.render(<Component />, document.getElementById('root'))
}

export const API_BASE_URL = config[window.location.hostname].baseAPIURL

render()
if (module.hot) {
  module.hot.accept(Component => {
    render()
  })
}



// WEBPACK FOOTER //
// ./src/index.js